import { SelectV2, SelectV2Option } from '@cimplico/components';
import { useEffect, useState } from 'react';
import { FieldType } from '../../types/custom-worksheet-v2';
import { formatMixedCase } from '../../utilities/formatting';

type FieldTypeSelectProps = {
    allowedTypes: FieldType[];
    autoFocus?: boolean;
    value?: FieldType;
    errorMessage?: string;
    disabledHint?: string;
    isDisabled?: boolean;
    onChange: (fieldType: FieldType[]) => void;
};

function FieldTypeSelect({
    allowedTypes,
    autoFocus = true,
    value,
    errorMessage,
    disabledHint,
    isDisabled,
    onChange,
}: FieldTypeSelectProps): JSX.Element {
    const [selected, setSelected] = useState<SelectV2Option[]>([]);
    const [search, setSearch] = useState('');

    function handleFieldTypeChange(options: SelectV2Option[]): void {
        onChange(options.map((o) => o.value as FieldType));
    }

    const options: { [key: string]: FieldType } = {
        Accounting: FieldType.ACCOUNTING,
        Money: FieldType.MONEY,
        Number: FieldType.NUMBER,
        Percent: FieldType.PERCENT,
        Date: FieldType.DATE,
        Text: FieldType.TEXT,
    };

    useEffect(() => {
        setSelected(value ? [{ label: formatMixedCase(value), value }] : []);
    }, [value]);

    return (
        <div className="w-full">
            <SelectV2
                autoFocus={autoFocus}
                keepSelectedOptions
                allowOverflow
                size="small"
                placeholder="Select field type..."
                errorMessage={errorMessage}
                value={selected}
                disabled={isDisabled}
                disabledHint={disabledHint}
                onSearch={setSearch}
                onChange={handleFieldTypeChange}
                options={Object.keys(options)
                    .filter((o) => allowedTypes.includes(options[o]))
                    .filter((opt) => opt.toLowerCase().includes(search.toLowerCase()))
                    .map((option) => {
                        return { label: option, value: options[option] };
                    })}
            />
        </div>
    );
}
export default FieldTypeSelect;
